/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const TrophyIcon = /*#__PURE__*/ createSvgIcon(
  'TrophyIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.5 4.34h2.71v1H1.523C1.789 8.28 4.389 10.66 8 10.66s6.211-2.38 6.477-5.32H12.79v-1h2.71v.5c0 3.794-3.214 6.82-7.5 6.82S.5 8.634.5 4.84v-.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.08 1.5h9.84V2c0 2.518-.116 4.893-.764 6.647-.327.887-.802 1.649-1.497 2.187-.7.543-1.582.826-2.659.826-1.077 0-1.958-.282-2.659-.824-.695-.538-1.17-1.299-1.498-2.185C3.197 6.898 3.08 4.523 3.08 2v-.5zm1.002 1c.016 2.327.16 4.345.7 5.804.284.771.668 1.352 1.171 1.74.498.386 1.154.616 2.047.616.893 0 1.55-.23 2.046-.616.504-.39.888-.972 1.173-1.743.539-1.46.683-3.479.7-5.801H4.081z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.716 10.66h2.568l.006.494a1.85 1.85 0 00.622 1.362l.024.022.022.024c.302.349.675.63 1.093.825l.289.134v.979H4.66v-.979l.289-.134a3.28 3.28 0 001.093-.825l.022-.024.024-.022a1.85 1.85 0 00.622-1.362l.006-.494zm.945 1a2.851 2.851 0 01-.884 1.582c-.08.09-.162.175-.248.258h2.942a4.305 4.305 0 01-.248-.258 2.85 2.85 0 01-.884-1.582h-.678z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.5 5.29h3.34v1H1.516c.26 4.105 3.72 7.42 8.484 7.42 4.764 0 8.223-3.315 8.484-7.42H16.16v-1h3.34v.5c0 4.928-4.036 8.92-9.5 8.92S.5 10.718.5 5.79v-.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.61 1.5h12.78V2c0 3.363-.156 6.5-1.007 8.806-.43 1.163-1.048 2.147-1.942 2.84-.9.696-2.037 1.064-3.441 1.064-1.347 0-2.453-.37-3.338-1.065-.879-.69-1.504-1.67-1.949-2.83C3.83 8.512 3.61 5.377 3.61 2v-.5zm1.002 1c.022 3.166.264 5.948 1.035 7.957.402 1.05.938 1.856 1.632 2.401.688.54 1.568.852 2.721.852 1.22 0 2.132-.316 2.829-.855.702-.544 1.229-1.348 1.616-2.396.742-2.01.927-4.79.944-7.959H4.612z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.504 13.71h3.092l.004.495a2.631 2.631 0 00.89 1.95l.025.021.021.025c.42.48.937.866 1.515 1.136l.289.134V18.5H5.76v-1.029l.289-.134A4.59 4.59 0 007.564 16.2l.021-.025.024-.021a2.63 2.63 0 00.891-1.95l.004-.495zm.958 1a3.63 3.63 0 01-1.167 2.173 5.586 5.586 0 01-.641.617h4.792a5.589 5.589 0 01-.641-.617 3.633 3.633 0 01-1.166-2.173H9.462z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.5 6.24h3.66v1H2.51c.234 5.314 4.174 9.52 9.49 9.52s9.256-4.206 9.49-9.52h-2.65v-1h3.66v.5c0 6.032-4.401 11.02-10.5 11.02S1.5 12.772 1.5 6.74v-.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.13 1.5h15.74V2c0 4.203-.196 8.104-1.252 10.96-.532 1.44-1.294 2.648-2.389 3.495-1.1.852-2.495 1.305-4.229 1.305-1.676 0-3.04-.455-4.126-1.305-1.08-.845-1.849-2.05-2.396-3.486C4.389 10.114 4.13 6.215 4.13 2v-.5zm1.001 1c.021 4.01.305 7.552 1.281 10.113.505 1.325 1.184 2.355 2.078 3.054.888.694 2.026 1.093 3.51 1.093 1.55 0 2.72-.402 3.617-1.096.903-.698 1.573-1.726 2.063-3.05.947-2.562 1.173-6.102 1.189-10.114H5.131z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.183 16.76h3.634l.003.497a3.42 3.42 0 001.143 2.53l.022.02.019.021a6.07 6.07 0 001.95 1.46l.286.135V22.5H6.76v-1.077l.287-.135a6.07 6.07 0 001.95-1.46l.018-.022.022-.02a3.42 3.42 0 001.143-2.53l.003-.496zm.966 1a4.42 4.42 0 01-1.424 2.753 7.072 7.072 0 01-1.088.987h6.726c-.395-.29-.76-.62-1.088-.987a4.42 4.42 0 01-1.424-2.753H11.15z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default TrophyIcon;
